import $ from "jquery";
import React, { Component } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class Operator2Article extends Component {
    constructor(props) {
        super(props);
        if (!Comm.ValidSession()) return;

        let sid = Context.GetContext().Sid;


        let articles = Comm.CallServerFunction("article/articleoperators", {
            session: sid
        }).articles;

        let operators = Comm.CallServerFunction("article/operatorarticles", {
            session: sid
        }).operators;
        console.log("operators", operators)

        this.state = {
            operators: operators,
            articles: articles,
            SelectedOperator: null,
            showMissingNameError: false,
        };

        this.EditOperator = this.EditOperator.bind(this);
        this.Save = this.Save.bind(this);
        this.IsChecked = this.IsChecked.bind(this);
        this.Check = this.Check.bind(this);
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;


        let self = this;

        return Context.HasRight("roperator2article") === true ? (
            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("operators")}</div>
                <div className="panel-body">
                    <div className="row">
                        <div className="col-md-5">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th width="90%">{Translation.Trans("name")}</th>
                                        <th width="10%"></th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="scrollableDiv">
                                <table className="table table-striped">
                                    <tbody>
                                        {self.state.operators.map((obj) =>
                                            <tr>
                                                <td width="90%">
                                                    <span
                                                        className={
                                                            this.state.SelectedOperator != null &&
                                                                this.state.SelectedOperator.id ===
                                                                obj.id
                                                                ? "btn btn-warning"
                                                                : null
                                                        }
                                                    >
                                                        <a
                                                            onClick={() => self.EditOperator(obj)}
                                                            className="pointhand"
                                                        >
                                                            {obj.name}
                                                        </a>
                                                    </span>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        {this.state.SelectedOperator !== null ? (
                            <div className="col-md-7 borderDiv scrollableDiv">
                                <div className="row">
                                    <div className="col-md-12">
                                        <label className="control-label">{Translation.Trans("article")}</label>
                                        <div>
                                            {self.state.articles.map(x =>
                                                <p><input type="checkbox" checked={self.IsChecked(x.id)} onClick={() => self.Check(x.id)} />{x.name}</p>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <button
                                            className="btn btn-primary pull-right"
                                            onClick={this.Save}
                                        >
                                            {Translation.Trans("save")}
                                        </button>

                                    </div>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        ) : (
            <div>{Translation.Trans("noRights")}</div>
        );
    }

    EditOperator(operator) {
        this.setState({ SelectedOperator: { id: operator.id, selected: new Set(operator.articles.map(x => x.id)) } });
    }

    Save() {

        let data = {};
        data.id = this.state.SelectedOperator.id;
        data.articles = [...this.state.SelectedOperator.selected]
        let sid = Context.GetContext().Sid;

        let postdata = JSON.stringify(data);

        Comm.CallServerFunction("article/saveoperatorarticles", {
            session: sid,
            operators: postdata
        })

        let operators = Comm.CallServerFunction("article/operatorarticles", {
            session: sid
        }).operators;

        this.setState({
            operators: operators,
            SelectedOperator: null,
            showMissingNameError: false,
        });
    }

    IsChecked(id) {

        return this.state.SelectedOperator.selected.has(id);
    }

    Check(id) {
        if (this.state.SelectedOperator.selected.has(id)) {
            this.state.SelectedOperator.selected.delete(id);
        }
        else {
            this.state.SelectedOperator.selected.add(id)
        }
        const newSet = new Set([...this.state.SelectedOperator.selected]);
        this.setState({ SelectedOperator: { id: this.state.SelectedOperator.id, selected: newSet } });
    }
}

export default Operator2Article;



// WEBPACK FOOTER //
// ./src/pages/operator2article.js